import React from "react";
import { Text } from "@zorni/components-lib";

import styles from "./UploadFileError.module.css";

/** Message d'erreur d'un champ fichier (refus côté interface). Rien si `message` est vide. */
const UploadFileError = ({ message }) => {
  if (!message) return null;

  return (
    <div className={styles.error} role="alert">
      <Text size="xs" color="danger">
        {message}
      </Text>
    </div>
  );
};

export default UploadFileError;
